import type React from 'react';

import { Link } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { BrainAtlasType, MultiLang } from '../config';

import styles from './CoverPage.module.css';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
}

const CoverPage: React.FC<Props> = (props) => {
    const { lang, type } = props;
    const links = [
        { title: 'Marmoset-3D Brain Atlas', url: '/marmoset/modules/xoonips/listitem.php?index_id=66' },
        {
            title: 'Marmoset-the MRI Standard Brain',
            url: '/marmoset/modules/xoonips/listitem.php?index_id=71',
        },
    ];
    if (type !== 'marmoset') {
        return <PageNotFound lang={lang} />;
    }
    return (
        <div className={styles.coverPage}>
            <ul className={styles.links}>
                {links.map((link) => (
                    <li key={link.title}>
                        <Link to={link.url}>{link.title}</Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CoverPage;
